import React from 'react';
export const CFIconPercent = {
    alias: 'percent',
    defaultTitle: 'Percent',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M19.74 4.261a.887.887 0 0 0-1.257 0L4.261 18.483a.886.886 0 0 0 0 1.257.889.889 0 0 0 1.257 0L19.74 5.518a.889.889 0 0 0 0-1.257ZM16 19c-.827 0-1.5-.673-1.5-1.5S15.173 16 16 16s1.5.673 1.5 1.5S16.827 19 16 19Zm0-5c-1.93 0-3.5 1.57-3.5 3.5S14.07 21 16 21s3.5-1.57 3.5-3.5S17.93 14 16 14ZM8 6c.827 0 1.5.673 1.5 1.5S8.827 9 8 9s-1.5-.673-1.5-1.5S7.173 6 8 6Zm0 5c1.93 0 3.5-1.57 3.5-3.5S9.93 4 8 4 4.5 5.57 4.5 7.5 6.07 11 8 11Z' }))),
};
